import { Component, OnInit, Type, ViewChild } from '@angular/core';
import { PersonSearchService } from '../_services/person-search.service';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import * as _ from 'underscore';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { LocalStorageService } from '../_services/local-storage.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { FilterParams } from '../common-interfaces-classes/FilterParams';
import { GeneralConstants } from '../constants/GeneralConstants';
import { SuggestedTitle } from '../openai/suggested-titles/suggested-titles.component';

@Component({
  selector: 'app-talentpool-insights',
  templateUrl: './talentpool-insights.component.html',
  styleUrls: ['./talentpool-insights.component.scss']
})
export class TalentpoolInsightsComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  private typeAheadSubject = new Subject<{event: Event, type: String}>();
  requestObject: any;
  jobTitleList:any = []
  skillsList:any=[]
  locationList: any;
  /**
   * Job Title Input for autocomplete
   */
  jobTitleInput: FormControl = new FormControl(null);
  /**
     * Job Title Selected List for autocomplete
     */
  jobTitleSelectedList: any = [];
  
  jobTitleTopList: any = [];
  
  locationInput: FormControl = new FormControl(null);
  locationSelectedList: any = [];
  // skills
  skillsInput: FormControl = new FormControl(null);
  
  skillsSelectedList: any = [];
  
  skillsTopList: any = [];
  regionEvent: Subject<any> = new Subject();
  showregion: string
  
  separatorKeysCodes: number[] = [ENTER, COMMA];
  
  pageNumber: number = 1;
  pageSize: number = 10;
  currentPage: number = 1;
  start: any //- start number for pagination (from)
  end: any //- end number for paginatuin (to)

  totalCandidatesCountLoading: boolean=false;
  totalCandidatesCount: any;
  showjobtitleloader: Boolean = false
  type: any

  keywordInput: FormControl = new FormControl(null);
  keywordsearch: any;
  searchDisable: Boolean = true;

  filterData: FilterParams;

  isOpenAITitleLoading: boolean = false;
  showOpenAITitleSuggestions: number;

  get openAITitles(): string {
    return this.jobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  isOpenAISkillsLoading: boolean = false;
  showOpenAISkillsSuggestions: number;

  get openAISkills(): string {
    return this.skillsSelectedList.filter(jt => !jt.isSuggestion).map(skill => `"${skill.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  get openAIAll(): string {
    return [this.openAITitles, this.openAISkills].filter(s => s).join(' OR ') || '';
  }

  constructor(
    private personSearchService:PersonSearchService,
    private router: Router,  private _localstorageservice: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService  
  ) { }

  ngOnInit(): void {
    this.filterDataHandlerService.reset();
    this.filterDataHandlerService.setBooleanQuery();
    this.filterData = this.filterDataHandlerService.fetchFilterData;

    this.showregion = this._localstorageservice.getItem('talentRegion')
    if(!this.showregion) {
      this.showregion = 'asia';
      this._localstorageservice.setItem('talentRegion', 'asia');
    }
    this.showregion = this.showregion ? this.showregion: 'asia';
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this.totalCandidatesCountLoading = true;
    this._localstorageservice.setItem('talentfilters', '')
    this.filterDataHandlerService.reset();
    this.filterDataHandlerService.setBooleanQuery();
    this._localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
    //this.buildReport()

    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({event,type})=>{
      this.typeAheadSearch(event, type);
    })

  }
    typeAheadSearch(event, type: String) {
      const requestObject = {
        "startindex": 0,
        "resultsize": 10,
        "searchviaboolean": true,
        "booleanquery": "*",
        "jobtitles": [],
        "preferredskills": [],
        "mandatoryskills": [],
        "locations": [],
        "companies": [],
        "industries": [],
        "exclusionlist": [],
        "genders": [
          "All"
        ],
        "seniority": [
          "All"
        ],
        "graduationyear": [],
        "schools": [],
        "schooltypes": [],
        "educationaldegrees": [],
        "educationalmajors": [],
        "candidateshavingemails": false,
        "candidateshavingcontactnumbers": false,
        "minexperience": null,
        "maxexperience": null,
        "minexperienceinccurrentcompany": null,
        "zipcodes": [],
        "companysizes": [
          "All"
        ],
        "candidateshavingcontacts": false,
        "workregions": [],
        "workcountries": [],
        "worklocalities": [],
        "spokenlanguages": [],
        "contacts": [
          "All"
        ],
        "candidateshavingmobilenumber": false,
        "candidateshavingpersonalemail": false,
        "candidateshavingprofessionalemail": false,
        "candidateshavingsocialprofiles": false,
        "fromgraduationyears": [],
        "tograduationyears": [],
        "exclude_jobtitles": [],
        "exclude_companies": [],
        "exclude_locations": [],
        "companytype": "Current",
        "jobtitletype": "Current",
        "industrytype": "Current",
        "fromyearsofexperience": [],
        "toyearsofexperience": [],
        "experiencetype": "Total",
        "likelytomovetype": null,
        "salaries": [
          "All"
        ],
        "salaryranges": [
          "All"
        ],
        "functions": [],
        "continentstobeincluded": [this._localstorageservice.getItem('talentRegion')]
      };
      const searchValue = event.target.value;
   //   const searchValue = (event.target as HTMLInputElement).value.trim();
    switch (type) {
      case 'jobtitle': {
        if(searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
            if (response.status == 'success') {
              this.jobTitleList = response.data.slice(0,10);

            }
          });
        }
    
        break
      }
      case 'skills':{
        if(searchValue.length > 2) {

        this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsList = response.data;
          }
        });
      }
        break;
      }
      case 'location': {
        if(searchValue.length > 2) {
          // let data = {
          //   keyword: searchValue,
          //   type: "location",
          //   continent: [this._localstorageservice.getItem('talentRegion')]
          // }
        this.personSearchService.getPersonSearchListing(searchValue,"location",this._localstorageservice.getItem('talentRegion') ).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.locationList = response.data;
        }
        });
      }
        break;
      }
    }
  }

  // Call the function whenever user type something
  onTypeAheadSearch(event: Event, type: String){
    // Emit the type and event as object through typeAheadSubject to apply debouce
    this.typeAheadSubject.next({event, type});
  }

  selectedItem(event, type, from:any = null) {
    if(event != '') {
      switch (type) {
        case "jobtitle": {
          this.jobTitleList = []
          if(from == 'enter')
            this.jobTitleSelectedList.push({key:event+".searchastext", chipkey:event, isExcluded: false, isMandatory: false});
          else
          this.jobTitleSelectedList.push({key:event.value+".searchastext", chipkey:event.value, isExcluded: false, isMandatory: false})
          this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, "key");
          this.jobTitleInput.reset();
          break;
        }
        case "skills": {
          this.skillsList = []
          if(from == 'enter')
            this.skillsSelectedList.push({key:event+".searchastext", chipkey:event, isExcluded: false, isMandatory: false})
          else
            this.skillsSelectedList.push({key:event.value, chipkey:event.value, isExcluded: false, isMandatory: false})
          this.skillsSelectedList = _.uniq(this.skillsSelectedList, "key");
          this.skillsInput.reset();
          break;
        }
        case "location": {
          this.locationList = []
          if(from == 'enter')
            this.locationSelectedList.push({key:event+".searchastext", chipkey:event, isExcluded: false, isMandatory: false})
          else
            this.locationSelectedList.push({key:event.value, chipkey:event.value, isExcluded: false, isMandatory: false})
          this.locationSelectedList = _.uniq(this.locationSelectedList, "key");
          this.locationInput.reset();
          break;
        }
      }
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.buildReport()
    }
  }
  removeChip(value, type) {
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.chipkey !== value);
        break;
      
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.chipkey !== value);
        break;
      
      case 'location':  
        this.locationSelectedList = this.locationSelectedList.filter(item => item.chipkey !== value);
        break;
     
    }
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    (this.jobTitleSelectedList.length || this.skillsSelectedList.length ) && this.buildReport()
  }

  selectedValue(searchValue){
    if(searchValue !== null || searchValue !== ""){
      this.keywordsearch = searchValue.trim();
      this.searchDisable = false;
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.buildReport()
    }
  }

  selectRegion(region) {
    this.showregion = region
    this._localstorageservice.setItem('talentRegion', region)
    this.regionEvent.next(this.showregion)
    this.buildReport()
  }
  buildReport(type?){
    this.requestObject = {
      startindex: 0,
      resultsize: 0,
      searchviaboolean: true,
      booleanquery: this.keywordsearch ? this.keywordsearch : "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList.map(jobTitle => jobTitle.key),
      preferredskills: this.skillsSelectedList.map(skill => skill.key),
      mandatoryskills: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: ['All'],
      seniority: ['All'],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: ['All'],
      candidateshavingcontacts: false,
      workregions: [],
      workcountries: [],
      worklocalities:[],
      spokenlanguages: [],
      contacts: [],
      candidateshavingmobilenumber: false,
      candidateshavingpersonalemail : false,
      candidateshavingprofessionalemail: false,
      candidateshavingsocialprofiles : false,
      companytype: 'All',
      jobtitletype: 'Current',
      industrytype: 'All',
      experiencetype: 'Total',
      fromyearsofexperience: [],
      toyearsofexperience: [],
      locations: this.locationSelectedList.map(l => l.key),
      continentstobeincluded: [this._localstorageservice.getItem('talentRegion')],
      functions: [],
      fullnames: [],
      aggregatetype: this.skillsSelectedList.length > 0 ? 'skills': 'current_jobtitle'

    }


    this.totalCandidatesCountLoading = true;
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.totalCandidatesCountLoading = false;
        this.totalCandidatesCount = response.data.totalresultscount;
        if(type=='redirect'){
          this.type = 'redirect';
          const filter = JSON.stringify({jobtitle: this.requestObject['jobtitles'], skills: this.requestObject['preferredskills'],location: this.requestObject['locations'], totalcount: this.totalCandidatesCount })
          this._localstorageservice.setItem('talentfilters', filter);
          this._localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterData));
          this.router.navigate([`/report-details/report-overview`], {queryParams:{keyword:this.keywordsearch}} );
        }
      }
    });
  }

    // not in indian format
    formatNumberToIndianFormat(number) {
      if(number){
        const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
        for (const suffix of suffixes) {
          if (Math.abs(number) < 1000) {
            return Math.floor(number) + suffix;
          }
          number /= 1000;
        }
        return Math.floor(number) + 'T';
      }else{
        return 0;
      }
    }
    resetFilters(){
      this.totalCandidatesCount = 0
      this.jobTitleSelectedList = []
      this.skillsSelectedList = []
      this.locationSelectedList = []
      this.keywordInput.patchValue(null);
      this.keywordsearch = null;
      this.searchDisable = true;
      this.filterData.booleanquery = _.clone(this.keywordsearch, true);

      this.requestObject = {
        startindex: this.start,
        resultsize: 10,
        searchviaboolean: true,
        booleanquery: "*",
        iscurrent: false,
        currentcompaniesonly: false,
        pastcompaniesonly: false,
        jobtitles:[],
        preferredskills:[],
        mandatoryskills: [],
        companies: [],
        industries: [],
        exclusionlist: [],
        genders: [],
        seniority: [],
        graduationyear: [],
        schools: [],
        schooltypes: [],
        educationaldegrees: [],
        educationalmajors: [],
        candidateshavingemails: false,
        candidateshavingcontactnumbers: false,
        minexperience: null,
        maxexperience: null,
        minexperienceinccurrentcompany: null,
        zipcodes: [],
        companysizes: [],
        candidateshavingcontacts: false,
        workregions: [],
        workcountries: [],
        worklocalities:[],
        spokenlanguages: [],
        contacts: [],
        candidateshavingmobilenumber: [],
        candidateshavingpersonalemail : [],
        candidateshavingprofessionalemail: [],
        candidateshavingsocialprofiles : [],
        companytype: [],
        jobtitletype: [],
        industrytype: [],
        experiencetype:[],
        fromyearsofexperience: [],
        toyearsofexperience: [],
        locations: [],
        continentstobeincluded: [this._localstorageservice.getItem('talentRegion')]
  
      }
      this.filterDataHandlerService.reset();
      this.filterDataHandlerService.setBooleanQuery();
      this.buildReport();
    }

    getemptytypeahead(type) {
      const requestObject = {
        "startindex": 0,
        "resultsize": 10,
        "searchviaboolean": true,
        "booleanquery": "*",
        "jobtitles": [],
        "preferredskills": [],
        "mandatoryskills": [],
        "locations": [],
        "companies": [],
        "industries": [],
        "exclusionlist": [],
        "genders": [
          "All"
        ],
        "seniority": [
          "All"
        ],
        "graduationyear": [],
        "schools": [],
        "schooltypes": [],
        "educationaldegrees": [],
        "educationalmajors": [],
        "candidateshavingemails": false,
        "candidateshavingcontactnumbers": false,
        "minexperience": null,
        "maxexperience": null,
        "minexperienceinccurrentcompany": null,
        "zipcodes": [],
        "companysizes": [
          "All"
        ],
        "candidateshavingcontacts": false,
        "workregions": [],
        "workcountries": [],
        "worklocalities": [],
        "spokenlanguages": [],
        "contacts": [
          "All"
        ],
        "candidateshavingmobilenumber": false,
        "candidateshavingpersonalemail": false,
        "candidateshavingprofessionalemail": false,
        "candidateshavingsocialprofiles": false,
        "fromgraduationyears": [],
        "tograduationyears": [],
        "exclude_jobtitles": [],
        "exclude_companies": [],
        "exclude_locations": [],
        "companytype": "Current",
        "jobtitletype": "Current",
        "industrytype": "Current",
        "fromyearsofexperience": [],
        "toyearsofexperience": [],
        "experiencetype": "Total",
        "likelytomovetype": null,
        "salaries": [
          "All"
        ],
        "salaryranges": [
          "All"
        ],
        "functions": [],
        "continentstobeincluded": [this._localstorageservice.getItem('talentRegion')]
      };
      const searchValue = 'a'
      if(type == 'jobtitle') {
        this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
          if (response.status == 'success') {
            this.jobTitleList = response.data.slice(0,10);
          }
        });
      } else if(type == 'skills') {
        this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
          if (response.status == 'success') {
            this.skillsList = response.data.slice(0,10);
          }
        });
      } else if(type == 'locations') {
        requestObject['typeahead'] = 'typeahead_location'
        requestObject['input'] = ''
        this.personSearchService.getTotalAggs(requestObject).subscribe((response: any) => {
          if (response.status == 'success') {
            this.locationList = response.data.aggs
          }
        });
      }
    }

    private syncFilterData() {
      this.filterData.jobTitleSelectedList = _.clone(this.jobTitleSelectedList, true);
      this.filterData.skillsSelectedList = _.clone(this.skillsSelectedList, true);
      this.filterData.locationSelectedList = _.clone(this.locationSelectedList, true);
      this.filterData.booleanquery = _.clone(this.keywordsearch, true);
    }

    openaiTitleLoading({ state, count }) {
      this.isOpenAITitleLoading = state;
      this.showOpenAITitleSuggestions = count;
    }
  
    setTitleSuggestions(suggestions: SuggestedTitle[]) {
      // generate key for each suggestion
      const suggestionsWithKey = suggestions.map(suggestion => {
        return {
          key: `${suggestion.name}.searchastext.aisearch`,
          chipkey: suggestion.name,
          isExcluded: false,
          isMandatory: false,
          isSuggestion: true,
          isSuggested: true,
          suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
        };
      });
      // existing suggestions
      const existingSuggestions = this.jobTitleSelectedList.filter(suggestion => suggestion.isSuggestion);
      // remove existing suggestions from new suggestions
      const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
      // add new suggestions to existing suggestions
      // @ts-ignore
      this.jobTitleSelectedList.push(...newSuggestions);
      if (newSuggestions.length) {
        this.syncFilterData();
        this.filterDataHandlerService.setFilterData(this.filterData);
        this.buildReport();
      }
    }
  
    openaiSkillsLoading({ state, count }) {
      this.isOpenAISkillsLoading = state;
      this.showOpenAISkillsSuggestions = count;
    }
  
    setSkillsSuggestions(suggestions: SuggestedTitle[]) {
      const suggestionsWithKey = suggestions.map(suggestion => {
        return {
          key: `${suggestion.name}.searchastext.aisearch`,
          chipkey: suggestion.name,
          isExcluded: false,
          isMandatory: false,
          isSuggestion: true,
          isSuggested: true,
          suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
        };
      });
      const existingSuggestions = this.skillsSelectedList.filter(suggestion => suggestion.isSuggestion);
      const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
      this.skillsSelectedList.push(...newSuggestions);
      if (newSuggestions.length) {
        this.syncFilterData();
        this.filterDataHandlerService.setFilterData(this.filterData);
        this.buildReport();
      }
    }

    private getSafeKey(str: string): string {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
    }
  
    removeTypeahead(type: any){
      const maxLength = 3
      switch (type) {
        case 'jobtitle': {
          if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
            this.jobTitleList = []
          }
          break;
        }
        case 'skills': {
          if (!(this.skillsInput && this.skillsInput.value && this.skillsInput.value.length >= maxLength)) {
            this.skillsList = []
          }
          break;
        }
        case 'location': {
          if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
            this.locationList = []
          }
          break;
        }
      }
    }
}
